export async function fetchDiscussionDetail({ hubSlug, threadId, user = null }) {
  const headers = {};
  if (user?.getIdToken) {
    const token = await user.getIdToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  const response = await fetch(
    `/api/discussions/${encodeURIComponent(hubSlug)}/${encodeURIComponent(threadId)}`,
    { headers, cache: "no-store" }
  );
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.error || "Discussion is unavailable");
    error.status = response.status;
    throw error;
  }
  return payload;
}
